module.exports = __webpack_public_path__ + "static/media/Asset 2ss.5a6785ca.png";